import { FC, useState } from 'react';

import { AnimatePresence, motion } from 'motion/react';
import { twMerge } from 'tailwind-merge';

import { Button } from '../../button';
import { SupportButtonIcon, X } from '../../../assets';
import { cn } from '../../../lib';
import { SupportPopover } from './SupportContent';
import { ISupport } from './types';

export const Support: FC<ISupport> = ({
  className,
  isShowMobile = false,
  isModal = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SupportPopover isOpen={isOpen} onOpenChange={setIsOpen} isModal={isModal}>
      <Button
        variant="secondary-foreground"
        className={cn(
          'fixed bottom-5 right-5 z-10 rounded-full backdrop-blur-[5px] [&_svg]:size-6',
          !isShowMobile && 'hidden onboarding-lg:block',
          className,
        )}
      >
        <AnimatePresence mode="wait">
          {isOpen ? (
            <motion.div
              key="open"
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
            >
              <X className="size-6" />
            </motion.div>
          ) : (
            <motion.div
              key="closed"
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
            >
              <SupportButtonIcon className={twMerge('size-6', className)} />
            </motion.div>
          )}
        </AnimatePresence>
      </Button>
    </SupportPopover>
  );
};
